import uuid from 'react-native-uuid';

import { GetPlayId } from './playId';

export const getPlayId: GetPlayId = (callback) => {
  callback(`${uuid.v4()}.${Date.now()}`);
};
